import React from "react";
import { putWithAuth } from "protocol-setup/redux/makeFetch";
import { submitProtocolPath } from "protocol-setup/redux/constants";
import {
  OpenErrorNotification,
  OpenSuccessNotification
} from "@ctsu/react-ctsu-ui";
import { titleAndAria } from "protocol-setup/constants/errorMessages";

const handleRequestSubmit = async (
  requestNumber,
  formPartType,
  requestStatus,
  onSuccessCallback
) => {
  try {
    await putWithAuth(submitProtocolPath, {
      requestNumber,
      formPartType,
      requestStatus
    });

    if (onSuccessCallback) {
      await onSuccessCallback();
    }
    OpenSuccessNotification({
      message: "Form is successfully submitted.",
      autoHide: true
    });
  } catch (error) {
    OpenErrorNotification({
      message:
        "Unable to complete the request. Contact CTSU Help Desk, ctsucontact@westat.com.",
      autoHide: true
    });
  }
};

const SubmitRequestBtn = ({
  requestNumber,
  isSubmitFormEnabled,
  formPartType,

  onSuccess
}) => {
  return (
    <button
      title={`${titleAndAria.submitRequest} ${requestNumber}`}
      type="button"
      className={`btn turquoise mx-1 ${isSubmitFormEnabled ? 'bg-blue' : ''}`}
      disabled={!isSubmitFormEnabled}
      onClick={() => {
        handleRequestSubmit(
          requestNumber,
          formPartType,
          "SUBMITTED",
          onSuccess
        );
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512"
        className="ml-0"
      >
        <path
          fill="currentColor"
          d="M218.2 424.1c-3-5.9-8.1-6.5-10.2-6.5s-7.2 .6-10 6.2l-7.7 15.3c-6.4 12.8-25 11.4-29.5-2.1L144 386.6l-10.6 31.9c-5.9 17.7-22.4 29.5-41 29.5H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h12.4c4.8 0 9.1-3.1 10.6-7.7l18.2-54.6c3.3-9.8 12.4-16.4 22.8-16.4s19.5 6.6 22.8 16.4l13.9 41.6c19.8-16.2 54.1-9.7 66 14.2 1.9 3.8 5.5 6 9.4 6.3v-82.1l128-127.1V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.1c-16.1-.3-30.6-9.3-37.8-23.8zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.1V416h69l161.7-162.8-67.9-67.9L288 347zm280.5-179.6l-31.9-31.9c-9.9-9.9-26.1-9.9-36 0l-27.3 27.3 67.9 67.9 27.3-27.3c10-9.9 10-26.1 0-36z"
        />
      </svg>
      Submit Request
    </button>
  );
};

export default SubmitRequestBtn;
